import { ApprovalState } from '../../@theme/type/approvalState';
import { MessageType } from '../type/message-type';
import { Sender } from './message';

/**
 * 결재요청시 사용되는 Message 
 */
export class RequestSharedDocument {
	id: string;
	state: ApprovalState;
	requestMessage: string;
	forwardMessage: string;

	/* 파일정보 */
	fileCount: number;

	sender: Sender;
	type: MessageType;

	created: Date;
	modified: Date;
	modifiedBy: string;
	deleted: Date;

	userCount: number;
	groupCount: number;

	constructor(obj?: any) {
		const message = obj || {};

		Object.assign(this, message);

		this.sender = message.userId ? new Sender({
			userId: message.userId,
			userName: message.userName,
			email: message.email,
			userAuthId: message.userAuthId,
			jobTitle: message.jobTitle,
			groupId: message.groupId,
			groupName: message.groupName,
			clientId: message.clientId,
			pcName: message.pcName,
			remoteIp: message.remoteIp,
			localIp: message.localIp
		}) : null;

		this.created = message.created ? new Date(message.created) : null;
		this.modified = message.modified ? new Date(message.modified) : null;
		this.deleted = message.deleted ? new Date(message.deleted) : null;
	}

	public get displayUserName() {
		return `${this.sender?.userName} ${(this.sender?.jobTitle ? '(' + this.sender?.jobTitle + ')' : '')}`;
	}

	public get user() {
		return {id: this.sender?.userId};
	}
}
